import { render, staticRenderFns } from "./supplement_pax.vue?vue&type=template&id=4d536c2c&"
import script from "./supplement_pax.vue?vue&type=script&lang=js&"
export * from "./supplement_pax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports